var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-item',{attrs:{"tag":"router-link","to":_vm.authenticated && _vm.activeOrg
      ? {
          name: 'legosHQRoute',
          params: { orgId: _vm.activeOrg.orgId },
        }
      : { name: 'landingRoute' }}},[_c('span',{staticClass:"tw-text-white tw-font-bold tw-text-2xl"},[_vm._v("flank")])])}
var staticRenderFns = []

export { render, staticRenderFns }